import { z } from "zod";
import { ScoredContentFitnessCoverageStatusSchema } from "../../enums/content-fitness";
import { HealthStateSchema, JobStatusSchema } from "../../enums/core";

export const ScanScheduleSchema = z.discriminatedUnion("mode", [
  z.object({
    mode: z.literal("manual_only"),
    nextScanAt: z.null(),
  }),
  z.object({
    mode: z.literal("scheduled"),
    nextScanAt: z.iso.datetime(),
  }),
]);

export type ScanSchedule = z.infer<typeof ScanScheduleSchema>;

// One row per website for the landing grid and command palette.
// Named *Health* to avoid colliding with website-config's WebsiteSummary.
export const WebsiteHealthSummarySchema = z.object({
  websiteId: z.uuid(),
  clientId: z.uuid(),
  clientName: z.string(),
  displayName: z.string().nullable(),
  domain: z.string(),
  signalScore: z.number().nullable(),
  scoreDelta: z.number().nullable(),
  scoreRunFinishedAt: z.coerce.date().nullable(),
  scoreRunCoverageStatus: ScoredContentFitnessCoverageStatusSchema.nullable(),
  healthState: HealthStateSchema,
  // The latest JOB's status, not the crawl run's — the two vocabularies are
  // different, and typing this `string` let them be confused.
  lastRunStatus: JobStatusSchema.nullable(),
  lastRunFinishedAt: z.coerce.date().nullable(),
  openIssueCount: z.number().int(),
  // Crawl run currently in progress, if any. jobs-based lastRun* fields keep
  // describing the previous landed run while this is set.
  activeRun: z
    .object({
      runId: z.uuid(),
      startedAt: z.coerce.date(),
    })
    .nullable(),
});

export const WebsiteHealthSummaryListSchema = z.array(
  WebsiteHealthSummarySchema,
);

export type WebsiteHealthSummary = z.infer<typeof WebsiteHealthSummarySchema>;
